/* eslint-disable */

import { getHodAndVillNames } from "pages/Home/Tools/ParcelsSearch";
import clearDuplicatedItemFromArrOfObject from "utils/clearDuplicatedItemFromArrOfObject";
import { fixParcelDataPadding } from "./getParcelsBasedCriteria";
import { NotificationManager } from "react-notifications";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

// eslint-disable-next-line consistent-return
export default async function joinVillsAndHodsIntoData({
  data,
  esriToken,
  villLayerId,
  hodLayerId,
}) {
  try {
    const villsAndHods = {};

    data.forEach((item) => {
      if (!villsAndHods[item.VILL_CODE]) {
        villsAndHods[item.VILL_CODE] = [];
      }
      villsAndHods[item.VILL_CODE].push(item.HOD_CODE);
    });
    const villQuery = `VILL_CODE IN (${Object.keys(villsAndHods)})`;
    const hodQuery = Object.entries(villsAndHods)
      .map(([key, value]) => `(VILL_CODE = ${key} AND HOD_CODE IN (${value}))`)
      .join(" OR ");
    const { vills: villsRes, hods: hodsRes } = await getHodAndVillNames({
      token: esriToken,
      villLayerId,
      hodLayerId,
      villQuery,
      hodQuery,
    });
    const villsResAsObject = {};
    villsRes.forEach((item) => {
      fixParcelDataPadding(item);
      villsResAsObject[item.VILL_CODE] = item;
    });
    const hodsResAsObject = {};
    hodsRes.forEach((item) => {
      fixParcelDataPadding(item);
      hodsResAsObject[item.HOD_CODE + item.VILL_CODE] = item;
    });
    //

    // add vill name and hod name
    const dataWithNames = data.map((item) => {

      return {
        ...item,
        HOD_ANAME: hodsResAsObject[item.HOD_CODE + item.VILL_CODE].HOD_ANAME,
        VILL_ANAME: villsResAsObject[item.VILL_CODE].VILL_ANAME,
        // IS_PRINTABLE: !isNotPrintableDlsKeys.includes(item.DLS_KEY),
      };
      
    });
    return {
      res: clearDuplicatedItemFromArrOfObject(dataWithNames, "DLS_KEY"),
      villsRes,
      hodsRes,
    };
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
  return {};
}
